import { useContext, useEffect, useMemo } from "react";
import useGetAwsPersonalizeProducts from "@/hooks/useGetAwsPersonalizeProducts";
import AWSPersonalizeCtx from "@/context/aws-personalize/aws-personalize-context";
import {
  CUSTOMER_WHO_VIEWED_ALSO_VIEWED,
  FREQUENTLY_BOUGHT_TOGETHER,
} from "@/services/global/aws-personalize";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";

const ProductsBulk = dynamic(() => import("./ProductsBulk"));

// integration with aws personalize

const PDPAWS = ({ productSku, mainCategory }) => {
  const { isDirectConnectToAWS, sendPersonalizeEvent } =
    useContext(AWSPersonalizeCtx);
  const {
    t,
    i18n: { language: locale },
  } = useTranslation("product");
  useEffect(() => {
    if (isDirectConnectToAWS && productSku) {
      sendPersonalizeEvent([
        {
          eventType: "View",
          sentAt: Date.now(),
          itemId: productSku,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirectConnectToAWS, productSku]);

  // get Frequently Bought Together Products from aws personalize
  const {
    products: frequentlyBoughtTogetherProducts,
    ratings: frequentlyBoughtTogetherRatings,
  } = useGetAwsPersonalizeProducts(FREQUENTLY_BOUGHT_TOGETHER, {
    itemId: productSku,
  });

  // get Also Viewed Products  from aws personalize
  const { products: alsoViewedProducts, ratings: alsoViewedRatings } =
    useGetAwsPersonalizeProducts(CUSTOMER_WHO_VIEWED_ALSO_VIEWED, {
      itemId: productSku,
    });
  const boughtTogetherProducts = useMemo(() => {
    return frequentlyBoughtTogetherProducts?.filter(
      (item) =>
        item?.stock?.is_in_stock &&
        +item?._category_?.main_category?.category_id === +mainCategory
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frequentlyBoughtTogetherProducts]);
  return (
    <>
      <section className="w-11/12 mx-auto">
        {boughtTogetherProducts?.length > 0 && (
          <ProductsBulk
            title={t("Frequently Bought Together Products")}
            products={boughtTogetherProducts?.map((product) => ({
              ...product,
              rating: Object.entries(frequentlyBoughtTogetherRatings)
                ?.find((r) => r?.at(0) === product.sku)
                ?.at(1) || { count: "0", rating: "0.0" },
            }))}
            locale={locale}
          />
        )}
      </section>
      <section className="w-11/12 mx-auto">
        {alsoViewedProducts?.filter((item) => item?.stock?.is_in_stock)
          ?.length > 0 && (
          <ProductsBulk
            title={t("Customer Who Viewed This Product Also Viewed")}
            products={alsoViewedProducts
              ?.filter((item) => item?.stock?.is_in_stock)
              .map((product) => ({
                ...product,
                rating: Object.entries(alsoViewedRatings)
                  ?.find((r) => r?.at(0) === product.sku)
                  ?.at(1) || { count: "0", rating: "0.0" },
              }))}
            locale={locale}
          />
        )}
      </section>
    </>
  );
};

export default PDPAWS;
